export const chapterKeys = {
  all: ["chapters"],
  lists: () => [...chapterKeys.all, "list"],
  list: () => [...chapterKeys.lists()],
  details: () => [...chapterKeys.all, "detail"],
  detail: (id) => [...chapterKeys.details(), id],
  stats: () => [...chapterKeys.all, "stats"],
  allStats: () => [...chapterKeys.all, "all-stats"],
};
